import React from "react";
import { render } from 'react-dom';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Global Styles
import "./assets/styles/index.css";

// Language deep-link: set cookie only when URL explicitly asks for it.
// Refresh without ?es/?en keeps the existing session language.
(() => {
  try {
    const groupId = (process.env.REACT_APP_GROUP_ID || '')
      .replace(/^['"]|['"]$/g, '')
      .trim();
    if (!groupId) return;

    const params = new URLSearchParams(window.location.search);
    const wantsSpanish =
      params.has('es') || params.get('lang') === 'es';
    const wantsEnglish =
      params.has('en') || params.get('lang') === 'en';

    if (wantsSpanish) {
      document.cookie = `locale_${groupId}=es; path=/; max-age=31536000; SameSite=Lax`;
    } else if (wantsEnglish) {
      document.cookie = `locale_${groupId}=en; path=/; max-age=31536000; SameSite=Lax`;
    }
  } catch (err) {
    // ignore — fall back to default English
    console.log(err);
  }
})();

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals(console.log);
